import { createDefaultSlide } from '../types/slide';
import { FOREST_BG_URLS } from './backgrounds';

/**
 * Initial slides with Magic Forest content
 * Used when creating a new carousel or when no carousels exist
 */
export function createInitialSlides() {
  const total = 10;
  const slides = Array.from({ length: total }, (_, i) =>
    createDefaultSlide(i, total, FOREST_BG_URLS.length)
  );

  // Override with specific content
  const content = [
    {
      title: 'START HERE',
      body: 'Let us tell you the story of Magic Forest. A community project where nature meets art.',
      meta: ['Forest', 'Art', 'Community'],
      cta: 'Swipe →',
    },
    {
      kicker: 'ABOUT',
      title: 'What is Magic Forest?',
      body: 'We unite people to plant forests and create a space for artists and community events—open, measurable, and human.',
      meta: ['Non-profit', 'Local', 'Long-term'],
    },
    {
      kicker: 'ROADMAP',
      title: 'From trees to a home',
      body: 'Crowdfund → choose land (10–20 ha) → plant the forest → grow the Art Hub with partners. €100k to start.',
      meta: ['Crowdfunding', 'Land', 'Art Hub'],
    },
    {
      kicker: 'JOIN',
      title: 'Be part of it',
      body: 'Follow along, share the story, or support the first step. Every contribution helps us secure land.',
      meta: ['Follow', 'Donate', 'Collaborate'],
    },
    {
      title: 'Transparency',
      body: 'A registered association with a clear roadmap: trees, land, and the Art Hub — step by step.',
      meta: ['Registered', 'Open updates', 'Catalonia'],
    },
    {
      title: 'What happens first',
      body: 'The first stage is simple and measurable. Then we scale — carefully, legally, and with partners.',
      bullets: ['Crowdfunding €100k', 'Land due diligence', 'Planting + care', 'Art Hub planning'],
    },
    // Slide 7 - Progress bar
    {
      title: 'Crowdfunding',
      body: 'The starting goal is €100,000. We publish progress and move to land selection once the goal is reached.',
      progress: { label: 'Raised', current: 588, total: 100000 },
    },
    // Slide 8 - Stats widgets
    {
      title: 'At a glance',
      body: 'A quick snapshot of where we are now and what we are building next.',
      stats: [
        { label: 'Goal', value: '€100k' },
        { label: 'Land', value: '10–20 ha' },
        { label: 'Stage', value: 'Pre-launch' },
      ],
    },
    // Slide 9 - Callout/quote widget
    {
      title: 'A note',
      body: 'Not everyone can plant a tree in person — so we built a way to do it together, transparently.',
      callout: { label: 'Community', text: 'Every contribution becomes part of a living forest.' },
    },
    // Slide 10 - Image widget
    {
      kicker: 'NEXT',
      title: 'The vision',
      body: 'A living forest + an Art Hub for workshops, exhibitions, and community gatherings.',
      imageWidget: { label: 'Art Hub', caption: 'A place where nature meets culture.', variant: 'illustration' },
      meta: ['Workshops', 'Exhibitions', 'Gatherings'],
      bgIndex: 0,
    },
  ];

  return slides.map((slide, i) => ({
    ...slide,
    ...content[i],
    cta: content[i].cta || `Slide ${i + 1} / ${total}`,
  }));
}
